import { AxiosError } from 'axios';
import { logError } from 'commerce/utils/ServerError';

export type NetworkError<E = Record<string, unknown>> = {
  status?: number;
  message?: string;
  data?: E;
};

export type FetchResponse<T, E = any> = {
  response?: T;
  error?: NetworkError<E>;
};

export async function errorWrapper<T extends any, E = any>(
  callbackName: string,
  callback: () => Promise<T> | undefined,
): Promise<FetchResponse<T, E>> {
  try {
    return Promise.resolve({ response: await callback() });
  } catch (error: any) {
    let parsedError: NetworkError<E>;
    let url: string = '';

    if (error instanceof AxiosError) {
      const errorJson: any = error?.toJSON();
      url = errorJson.config.url;

      parsedError = {
        status: errorJson.status,
        message: errorJson.message,
        data: (error.response as any)?.data || null,
      };
    } else if (typeof error === 'string') {
      parsedError = JSON.parse(error);
    } else {
      parsedError = error;
    }

    if (parsedError.status === 404) {
      return Promise.resolve({ error: parsedError });
    }

    if (typeof window === 'undefined') {
      logError(
        `fetch of ${callbackName}${url ? ` - ${url}` : ''}`,
        parsedError,
      );
    } else {
      console.error(
        `fetch of ${callbackName}${url ? ` - ${url}` : ''}`,
        parsedError,
      );
    }

    return Promise.resolve({ error: parsedError });
  }
}
